import React from 'react';
import { Link } from 'react-router-dom';
export function Navbar() {
  return <header className="absolute top-0 left-0 w-full flex justify-between items-center p-6 md:px-12 z-20" data-id="element-46">
      <Link to="/" className="font-black text-2xl tracking-tight text-black no-underline" data-id="element-47">
        Waitlist.
      </Link>
      <nav className="flex gap-6 text-gray-600 font-medium text-sm md:text-base" data-id="element-48">
        <Link to="/demo" className="hover:text-black transition-colors" data-id="element-49">
          Demo
        </Link>
        <Link to="/use-cases" className="hover:text-black transition-colors" data-id="element-50">
          Use Cases
        </Link>
      </nav>
    </header>;
}